import { Vue, Component, Watch } from 'vue-property-decorator'

import { ServerModule } from 'shared/state'
import { Collection } from 'shared/types'
import {
	Machine, RaceState, RaceDefinition, RaceStatus, RaceStatusData,
	RaceData, RaceResults, RaceDataSplit, MachineType, PreRaceT
} from 'shared/types/erg'
import { makeComputedBinding, sortByKeyAsc, sortByKeyDesc } from 'shared/util'
import { initialCap, formatTime } from 'shared/util'
import { ErgState, Erg } from 'shared/state'

@Component
class PreRaceModule extends Vue {

	private get serverState() { return this.server ? this.server.state : 'unconnected' }
	@ErgState() status
	public pre_race: PreRaceT | null = null
	private server: ServerModule | null = null
	private subscription: number | null = null

	attachToServer(server: ServerModule) {
		this.server = server
	}
	@Watch('status', {immediate: true, deep: true})
	statusChanged(newVal) {
		if(newVal && newVal === 'final results') {
			this.pre_race = null
		}
	}

	private remote_ergrace_action(message: any) {
		if(message?.action === 'change_setting' && message?.config?.pre_race) {
			this.pre_race = message.config.pre_race
		}
	}

	@Watch('serverState')
	private serverStateChange() {
		// the server might reconnect after its first connection, but we only want to add our listener once
		if(this.serverState === 'connected' && this.subscription == null) {
			this.subscription = this.server!.addListener((channel, packet) => {
				if(this[channel] && typeof this[channel] === 'function') {
					this[channel](packet)
				}
			})
		}
		if(this.serverState !== 'connected') {
			//
		}
	}
}

export const PreRace = new PreRaceModule()
export const PreRaceState = makeComputedBinding(PreRace)
